const smartId = require('../../tools/smart-id')

const countries = {
  ng: {
    dialCode: '234',
    currencyCode: 'NGN',
    expectedLength: 13,
    name: 'Nigeria',
    localPattern: /^[789]\d{9}$/
  },
  ke: {
    dialCode: '254',
    currencyCode: 'KES',
    expectedLength: 12,
    name: 'Kenya',
    localPattern: /^(1\d{8}|7[0-6]\d{7})$/
  },
  rw: {
    dialCode: '250',
    currencyCode: 'RWF',
    expectedLength: 12,
    name: 'Rwanda',
    localPattern: /^7[8-9]\d{7}$/
  }
}

const validNumberRegex = /^(254|234|250)\d*$/

function throwGetCountryInfoError (location) {
  throw new Error(`could not match fsid to country codes ${Object.keys(countries).join(',')} in location: ${JSON.stringify(location)}`)
}

function getCountryInfo (location) {
  const {fsid} = location
  const {country} = smartId.parse(fsid)

  const countryInfo = countries[country]

  if (countryInfo) {
    return countryInfo
  }
  throwGetCountryInfoError(location)
}

function getIntlPhoneNumber (location) {
  const {
    owners_phone_number: phoneNumber,
    alt_phone_number: altPhoneNumber
  } = location

  const countryInfo = getCountryInfo(location)

  const {
    dialCode
  } = countryInfo

  const givenNumber = phoneNumber || altPhoneNumber

  if (!givenNumber) {
    throw new Error('no number given for location')
  }

  // we expect international numbers without + or 00 prefix
  // check for 00 or + first or else checking for dialcode first will break testing with non NG/KE numbers
  if (givenNumber.startsWith('00')) {
    return givenNumber.replace('00', '')
  }

  if (givenNumber.startsWith('+')) {
    return givenNumber.replace('+', '')
  }

  if (givenNumber.startsWith(dialCode + '-')) {
    return givenNumber.replace('-', '')
  }

  if (givenNumber.startsWith(dialCode)) {
    return givenNumber
  }

  if (givenNumber.startsWith('0')) {
    return givenNumber.replace('0', dialCode)
  }

  return `${dialCode}${givenNumber}`
}

const getCountryByPhoneNumber = (phoneNumber) => {
  const matched = phoneNumber.match(validNumberRegex)
  if (!matched) {
    return null
  }
  const countryCode = matched[1]
  const country = Object.entries(countries).find(([, countryData]) => countryData.dialCode === countryCode)
  return country ? country[0] : null
}

const getCountryCodesForPhoneInput = () => {
  return Object.entries(countries).map(([countryKey, countryData]) => ({
    label: `+${countryData.dialCode}`,
    value: `+${countryData.dialCode}`,
    country: countryKey,
    name: countryData.name,
    expectedLength: countryData.expectedLength
  }))
}

const getDefaultCountryCode = () => {
  return `+${countries.ng.dialCode}`
}

module.exports = {
  getCountryInfo,
  getIntlPhoneNumber,
  validNumberRegex,
  getCountryByPhoneNumber,
  countries,
  getCountryCodesForPhoneInput,
  getDefaultCountryCode
}
